/* @flow */
import { combineReducers } from 'redux-immutable';
import { OrderedMap, fromJS } from 'immutable';
import type { Action } from 'trustar/utils/redux-types.js';

import {
  SET_DISPLAY_OPTIONS,
} from './action-types.js';

import { Options } from './types.js';
import type { RawOptions } from './types.js';

export const options = (state: typeof Options = Options(), action: Action<RawOptions>) => {
  const { type, payload } = action;

  switch (type) {
  case SET_DISPLAY_OPTIONS:
    return state.merge(payload);
  default:
    return state;
  }
};

export const loading = (state: boolean = true, action: Action<any>) => {
  return false;
};

export default combineReducers({
  options,
  loading,
});



// WEBPACK FOOTER //
// ./src/app/modules/marketplace/stores.js